import React from "react";
import { Form, Input, Radio, Select, Rate } from "antd";
const { Option, OptGroup } = Select;
export function FormComponent({
  formItemLayout,
  getFieldDecorator,
  input,
  option,
  showOther,
  onChange,
  onSearch,
  technicalSkills,
  itemData
}) {
  // 
  const isEdit = itemData !== null;

  return (

    <Form {...formItemLayout}>
      <p><b>(If your skill not listed in dropdown, you can select OTHER and enter the skill name)</b></p>
      <Form.Item label="Skill name " className="formsteponeinout">
        {getFieldDecorator("skillName", {
          initialValue: itemData
            ? itemData.type === "Other"
              ? "Other"
              : itemData.skillName
            : undefined,
          rules: [
            {
              required: true,
              message: "Please select your skill name (You can select OTHER and fill the skill name, if your skill not listed in dripdown)"
            },
            {
              validator: (rule, value, callback) => {
                var c = [];
                Object.keys(technicalSkills).forEach(i => {
                  c.push(i);
                });

                if (c.includes(value) && value !== "Other" && !isEdit) {
                  callback(
                    "You have already added " +
                      value +
                      " skill to your profile. Delete it first if you would like to add as new one"
                  );
                } else {
                  callback();
                }
              }
            }
          ]
        })(
          <Select
            showSearch
            style={{
              width: 200
            }}
            placeholder="Search or Select your skill"
            optionFilterProp="children"
            onChange={onChange}
            disabled={isEdit}
            filterOption={(input, option) => {
              if (typeof option.props.label === "undefined") {
                return (
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                );
              } else {
                return false;
              }
            }}
          >
            <OptGroup label="Programming">
              <Option value="C">C</Option>
              <Option value="C-Plus-Plus">C++</Option>
              <Option value="C-Sharp">C#</Option>
              <Option value="Java">Java</Option>
              <Option value="Python">Python</Option>
              <Option value="Javascript">JavaScript</Option>
              <Option value="PHP">PHP</Option>
              <Option value="Swift">Swift</Option>
              <Option value="Ruby">Ruby</Option>
              <Option value="R">R-Programming</Option>
              <Option value="DotNet">Dot Net</Option>
              <Option value="VLSI">VLSI</Option>
            </OptGroup>
            <OptGroup label="Application Development">
              <Option value="Html">HTML</Option>
              <Option value="CSS">CSS</Option>
              <Option value="Bootstrap">Bootstrap</Option>
              <Option value="React">React</Option>
              <Option value="AngularJS">Angular JS</Option>
              <Option value="VueJS">VueJS</Option>
              <Option value="NodeJS">NodeJS</Option>
              <Option value="Android">Android Development</Option>
              <Option value="IOS">IOS Development</Option>
              <Option value="FLUTTER">Flutter</Option>
              <Option value="REACTNATIVE">React Native</Option>
              <Option value="HTML">Blockchain</Option>
              <Option value="ML">Machine Learning</Option>
              <Option value="AI">Artificial Intelligence</Option>
              <Option value="IoT">Internet Of Things</Option>
              <Option value="VR">Virtual Reality</Option>
              <Option value="AR">Augmented Reality</Option>
              <Option value="UNITY">Unity / Gaming Development</Option>
              <Option value="Robotics">Robotics</Option>
              <Option value="CAD">Auto CAD</Option>
              <Option value="CATIA">CATIA</Option>
              <Option value="LABVIEW">Lab View</Option>
              <Option value="Embedded">Embedded</Option>
              <Option value="Drone">Drone Development</Option>
              <Option value="AWS">AWS</Option>
              <Option value="GCloud">Google Cloud</Option>
              <Option value="Firebase">Firebase</Option>
              <Option value="NoCode">No Code Platforms</Option>
            </OptGroup>
            <OptGroup label="Database">
              <Option value="SQL">SQL</Option>
              <Option value="NoSQL">NoSQL</Option>
            </OptGroup>
            <OptGroup label="If Not in the list, Select Other">
              <Option value="Other">Other</Option>
            </OptGroup>
          </Select>
        )}
      </Form.Item>
      {showOther ? (
        <Form.Item label="Skill Name" className="formsteponeinout">
          {getFieldDecorator("otherSkillName", {
            initialValue: itemData ? itemData.skillName : undefined,

            rules: [
              {
                required: true,
                message: "Please enter your skill name"
              }
            ]
          })(
            <Input
              // value={technicalSkills ? technicalSkills : null}
              disabled={isEdit}
            />
          )}
        </Form.Item>
      ) : null}

      <Form.Item className="formsteponeinout" label="Rate your skill level">
        {getFieldDecorator("skillRate", {
          initialValue: itemData ? itemData.skillRate : 0.5,
          rules: [
            {
              required: true,
              message: "Rate it"
            }
          ]
        })(
          <Rate
            allowHalf
            tooltips={[
              "Elementary",
              "Basic",
              "Intermediate",
              "Advanced",
              "Professional"
            ]}
            allowClear={true}
          />
        )}
      </Form.Item>

      <Form.Item
        label="Where did you learn this skill?"
        className="formsteponeinout"
      >
        {getFieldDecorator("skillWhere", {
          initialValue: itemData ? itemData.skillWhere : undefined,
          rules: [
            {
              required: true,
              message: "Tell us where did you learn this skill?"
            }
          ]
        })(
          <Select
            showSearch
            style={{
              width: 200
            }}
            placeholder="Select"
            optionFilterProp="children"
            onSearch={onSearch}
            filterOption={(input, option) =>
              option.props.children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            }
          >
            <Option value="college">In College Curriculum</Option>
            <Option value="workshop">At Workshop</Option>
            <Option value="Internship">At Internship</Option>
            <Option value="Online Website">Online Websites</Option>
            <Option value="self">Self</Option>
            <Option value="others">Others</Option>
          </Select>
        )}
      </Form.Item>

      <Form.Item
        label="Are you willing to improve this skill?"
        className="formsteponeinout"
      >
        {getFieldDecorator("reskillIT", {
          initialValue: `${itemData ? itemData.reskillIT : ""}`,
          rules: [
            {
              required: true,
              message: "Please select the answer"
            }
          ]
        })(
          <Radio.Group>
            <Radio value="yes">YES</Radio>
            <Radio value="no">No</Radio>
          </Radio.Group>
        )}
      </Form.Item>
    </Form>
  );
}
